import { DEV_MODE } from '../../global/env';
import { isFunction } from '../../utils/unit';
import { isReactiveElementProto, throwIfTC39Decorator } from '../elements/decorators';
import { isDerviedContext } from './context';
export function consumeContext(context, options = {}) {
    return function (proto, propertyKey) {
        const decoratorName = consumeContext.name;
        // TODO: implement when spec formalized.
        throwIfTC39Decorator(decoratorName, proto);
        if (isReactiveElementProto(decoratorName, proto)) {
            const ctor = proto.constructor;
            defineContextConsumer(ctor, propertyKey, context, options);
        }
    };
}
export function provideContext(context, options = {}) {
    return function (proto, propertyKey) {
        const decoratorName = provideContext.name;
        // TODO: implement when spec formalized.
        throwIfTC39Decorator(decoratorName, proto);
        if (isReactiveElementProto(decoratorName, proto)) {
            const ctor = proto.constructor;
            defineContextProvider(ctor, propertyKey, context, options);
        }
    };
}
export function watchContext(context, options = {}) {
    return function (proto, methodName) {
        const decoratorName = watchContext.name;
        // TODO: implement when spec formalized.
        throwIfTC39Decorator(decoratorName, proto);
        if (isReactiveElementProto(decoratorName, proto)) {
            const ctor = proto.constructor;
            defineContextConsumer(ctor, Symbol(`Vidstack.${String(methodName)}`), context, Object.assign(Object.assign({}, options), { onUpdate(newValue) {
                    var _a;
                    if (isFunction(this[methodName]))
                        this[methodName](newValue);
                    (_a = options === null || options === void 0 ? void 0 : options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, newValue);
                } }));
        }
    };
}
const PROVIDERS = Symbol('Vidstack.providers');
const CONSUMERS = Symbol('Vidstack.consumers');
export function defineContextProvider(ctor, name, context, options = {}) {
    var _a;
    // Might be called by decorator.
    // @ts-expect-error
    (_a = ctor.finalizeContext) === null || _a === void 0 ? void 0 : _a.call(ctor);
    ctor.addInitializer((element) => {
        if (!(element instanceof ctor))
            return;
        if (!element[PROVIDERS])
            element[PROVIDERS] = new Map();
        const provider = context.provide(element, Object.assign({ 
            /* c8 ignore next */
            name: DEV_MODE && name }, options));
        element[PROVIDERS].set(name, provider);
    });
    Object.defineProperty(ctor.prototype, name, {
        enumerable: true,
        configurable: true,
        get() {
            return this[PROVIDERS].get(name).value;
        },
        set: isDerviedContext(context)
            ? function () { }
            : function (newValue) {
                // @ts-expect-error
                this[PROVIDERS].get(name).value = newValue;
            }
    });
}
export function defineContextConsumer(ctor, name, context, options = {}) {
    var _a;
    // Might be called by decorator.
    // @ts-expect-error
    (_a = ctor.finalizeContext) === null || _a === void 0 ? void 0 : _a.call(ctor);
    ctor.addInitializer((element) => {
        var _a, _b;
        if (!(element instanceof ctor))
            return;
        let oldValue = (_b = (_a = options.transform) === null || _a === void 0 ? void 0 : _a.call(options, context.initialValue)) !== null && _b !== void 0 ? _b : context.initialValue;
        context.consume(element, Object.assign(Object.assign({ 
            /* c8 ignore next */
            name: DEV_MODE && name }, options), { onUpdate: (newValue) => {
                var _a;
                (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(element, newValue);
                // Ignore watchers.
                if (typeof name === 'symbol' &&
                    name.toString().startsWith('Vidstack.')) {
                    return;
                }
                // Trigger setters.
                element[name] = newValue;
                if (options.shouldRequestUpdate) {
                    element.requestUpdate(name, oldValue);
                    oldValue = newValue;
                }
            } }));
    });
}
